import {
  GET_HORSE_RACE_AUTHORS,
  GET_HORSE_RACE_AUTHORS_SUCCESS,
  GET_HORSE_RACE_AUTHORS_FAILURE,
  GET_HORSE_RACE_AUTHOR_DETAILS,
  GET_HORSE_RACE_AUTHOR_DETAILS_SUCCESS,
  GET_HORSE_RACE_AUTHOR_DETAILS_FAILURE,
  GET_HORSE_RACE_AUTHOR_COMMENTS,
  GET_HORSE_RACE_AUTHOR_COMMENTS_SUCCESS,
  GET_HORSE_RACE_AUTHOR_COMMENTS_FAILURE,
  SET_FROM_AUTHOR_DATA,
  CLEAR_FROM_AUTHOR_DATA

} from 'Store/constants';


const initialState = {
  data: [],
  authors: [],
  authorDetail: {},
  isLoading: true,
  playedData: {},
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_HORSE_RACE_AUTHORS:
      return { ...state, isLoading: true, error: null };
    case GET_HORSE_RACE_AUTHORS_SUCCESS:
      return { ...state, authors: action.payload, isLoading: false, error: null };
    case GET_HORSE_RACE_AUTHORS_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    case GET_HORSE_RACE_AUTHOR_DETAILS:
      return { ...state, isLoading: true, error: null };
    case GET_HORSE_RACE_AUTHOR_DETAILS_SUCCESS:
      return { ...state, authorDetail: action.payload, isLoading: false, error: null };
    case GET_HORSE_RACE_AUTHOR_DETAILS_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    case GET_HORSE_RACE_AUTHOR_COMMENTS:
      return { ...state, isLoading: true, error: null };
    case GET_HORSE_RACE_AUTHOR_COMMENTS_SUCCESS:
      return { ...state, data: action.payload, isLoading: false, error: null };
    case GET_HORSE_RACE_AUTHOR_COMMENTS_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    case SET_FROM_AUTHOR_DATA : {
      return { ...state, playedData: { ...action.payload } };
    }
    case CLEAR_FROM_AUTHOR_DATA : {
      return { ...state, playedData: {} };
    }
    default:
      return state;
  }
};